/* eslint-disable check-file/filename-blocklist */
export enum UserTypes {
	ANONYMOUS = 'anonymous',
	ORG_MEMBER = 'org-member',
	CONFLUENCE_USER = 'confluence-user',
	ATLASSIAN_USER = 'atlassian-user',
}

export const ANALYTICS_SOURCE = 'externalSharePageScreen';
export const LEARN_MORE_URL = `https://www.atlassian.com/software/confluence?utm_source=in-product-banner&utm_medium=in-product&utm_campaign=P:confluence|O:confluence-permissions|F:evaluation|C:signup|H:fy23q2|I:public-links|E:cloud|`;
export const TRY_CONFLUENCE_ROUTE = `/try/cloud/signup?bundle=confluence&edition=free&utm_source=in-product-banner&utm_medium=in-product&utm_campaign=P:confluence|O:confluence-permissions|F:evaluation|C:signup|H:fy23q2|I:public-links|E:cloud|`;

export const PRODUCTION_WAC_DOMAIN = 'https://www.atlassian.com';
export const STAGING_WAC_DOMAIN = 'https://wac.stg.internal.atlassian.com';
